import { useParams } from "react-router";
import { MainPadding } from "../../../styles/Main.styles";
import { useGetInvoice } from "../api/invoice/resolver";
import Spinner from "../../../components/spinner/Spinner";
import FormInvoiceLunas from "../form/invoice/lunas/Form";
import { Box, Typography } from "@mui/material";
import FormBelumLunas from "../form/invoice/belum_lunas/Form";
import FormAdd from "../form/invoice/add/Form";

export default function Creation() {
  const { idInvoice } = useParams();
  const { data: dataRawInvoiceDetail, isLoading } = useGetInvoice({
    invoice_id: idInvoice,
  });
  const dataInvoiceDetail = dataRawInvoiceDetail?.data.data;

  if (!idInvoice) {
    return (
      <MainPadding>
        <FormAdd />
      </MainPadding>
    );
  }

  if (idInvoice && isLoading) {
    return (
      <MainPadding>
        <Spinner />
      </MainPadding>
    );
  }

  if (dataInvoiceDetail === undefined) {
    return (
      <MainPadding>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          <Typography>Data Invoice Tidak Ditemukan</Typography>
        </Box>
      </MainPadding>
    );
  }

  return (
    <MainPadding>
      {dataInvoiceDetail.status.toString() === "2" ||
      dataInvoiceDetail.status.toString() === "-1" ? (
        <FormInvoiceLunas
          hideRetur={dataInvoiceDetail.status.toString() === "-1"}
          dataInvoice={dataInvoiceDetail}
        />
      ) : (
        <FormBelumLunas dataInvoice={dataInvoiceDetail} />
      )}
    </MainPadding>
  );
}
